<template>
  <div class="apply-list-wrap"
       v-loading="loading"
       element-loading-text="加载中……"
       element-loading-spinner="el-icon-loading">

    <div v-if="groupList.length" class="apply-group-list">
      <div v-for="group in groupList" :key="group.rowKey" class="apply-group">
        <div class="group-card" :class="{ open: isExpanded(group) }" @click="toggleGroup(group)">
          <div class="group-card-left">
            <span class="group-dot"/>
            <div class="group-title-wrap">
              <span class="group-name">{{ group.group_name || '未分组' }}</span>
              <span class="group-total">{{ group.total }}人</span>
            </div>
          </div>
          <div class="group-card-right">
            <div class="group-progress">
              <el-progress
                  :percentage="group.progress"
                  :stroke-width="6"
                  :show-text="false"
                  color="#5b6cff"/>
            </div>
            <span class="group-ratio">{{ group.appliedCount }}/{{ group.total }}</span>
            <i class="el-icon-arrow-right group-arrow" :class="{ open: isExpanded(group) }"/>
          </div>
        </div>

        <div v-show="isExpanded(group)" class="detail-wrap">
          <div class="detail-head">
            <span>红人</span>
            <span>合作意向</span>
            <span>预备档期</span>
            <span>报名平台</span>
            <span>备注</span>
            <span>状态</span>
            <span>操作</span>
          </div>
          <div v-for="item in group.children" :key="item.rowKey"
               class="kol-row"
               :class="{ 'row-active': item.rowKey === activeRowKey, 'row-disabled': item.isLocked, 'is-applied-row': item.isApplied }"
               @click="setActive(item)">
            <div v-if="item.isApplied" class="row-watermark" aria-hidden="true">
              <span v-for="idx in 10" :key="idx">已报名</span>
            </div>

            <div class="kol-cell">
              <div class="kol-avatar" :style="{ backgroundColor: getAvatarColor(item.nickname) }">
                <img v-if="item.avatar" :src="item.avatar" alt="avatar"/>
                <span v-else>{{ getAvatarText(item.nickname) }}</span>
              </div>
              <div class="kol-info">
                <div class="kol-name">
                  <span v-if="item.is_assign === 1" class="assign-tag">定向</span>
                  <span class="kol-name-text">{{ item.nickname || '-' }}</span>
                </div>
                <div class="kol-sub">{{ item.group_name || group.group_name || '-' }}</div>
              </div>
            </div>

            <div class="intention-cell">
              <div class="intention-switch">
                <span
                    v-for="option in intentionOptions"
                    :key="option.value"
                    class="switch-seg"
                    :class="{ active: Number(item.intention) === option.value }"
                    @click="setIntention(item, option.value)">
                  {{ option.label }}
                </span>
              </div>
            </div>

            <div class="schedule-cell">
              <el-input
                  v-model="item.intention_note"
                  class="intention-note-input"
                  :disabled="item.isLocked || item.applyLoading"
                  placeholder="可选预备档期"
                  clearable
                  size="mini"
                  @focus="setActive(item)"
                  @blur="clearActive(item)"/>
            </div>

            <div class="platform-group">
              <div v-if="getPlatformOptions(item).length" class="platform-group-inner">
                <span
                    v-for="platform in getPlatformOptions(item)"
                    :key="platform.value"
                    class="platform-chip"
                    :class="{
                    applied: platform.applied,
                    selected: platform.selected && !platform.applied,
                    disabled: item.isLocked || platform.applied
                  }" :style="getPlatformStyle(platform)"
                    @click="togglePlatform(item, platform)">
                  <span v-if="platform.applied || platform.selected" class="platform-check">
                    <i class="el-icon-check"></i>
                  </span>
                  <span v-else class="platform-dot" :style="{ backgroundColor: platform.color }"></span>
                  {{ platform.name }} - {{ platform?.journal?.account_id }}
                </span>
              </div>
              <span v-else class="muted">-</span>
            </div>

            <div class="note-cell">
              <el-input
                  v-model="item.note"
                  class="note-input"
                  :disabled="item.isLocked || item.applyLoading"
                  placeholder="备注..."
                  clearable
                  size="mini"
                  @focus="setActive(item)"
                  @blur="clearActive(item)"/>
            </div>

            <div class="status-cell">
              <span class="status-pill" :class="getStatusClass(item)">
                <i class="status-dot"></i>
                {{ getStatusText(item) }}
              </span>
            </div>

            <div class="action-cell">
              <el-button
                  type="primary"
                  size="mini"
                  :icon="item.isApplied ? 'el-icon-success' : 'el-icon-circle-check'"
                  :loading="item.applyLoading"
                  :disabled="!canApply(item)"
                  @click="handleApply(item)">
                {{ getActionText(item) }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-text">暂无报名列表</div>
    <transition name="el-fade-in">
      <div v-if="batchRows.length >= 2" class="batch-apply-float" @click="handleBatchApply">
        <i class="el-icon-s-promotion"></i>
        <span>批量报名（{{ batchRows.length }}）</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'applyTable',
  props: {
    //合作平台
    infoPlatforms: {
      type: Array,
      default() {
        return []
      }
    },
    infoStatus: {
      type: Object,
      default() {
        return {}
      }
    },
    packagePlatforms: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      projectId: '',
      groupList: [],
      expandRowKeys: [],
      activeRowKey: '',
      intentionOptions: [
        {label: '试用', value: 1},
        {label: '可接', value: 2}
      ],
      batchLoading: false
    }
  },
  computed: {
    // 已勾选报名平台的红人（checkList 非空即视为已选择平台）
    batchRows() {
      const rows = []
      this.groupList.forEach((group) => {
        (group.children || []).forEach((item) => {
          if (Array.isArray(item.checkList) && item.checkList.length > 0) {
            rows.push(item)
          }
        })
      })
      return rows
    }
  },
  methods: {
    isExpanded(row) {
      return this.expandRowKeys.includes(row.rowKey)
    },
    toggleGroup(row) {
      const key = row.rowKey
      this.expandRowKeys = this.isExpanded(row) ? [] : [key]
    },
    setIntention(row, value) {
      if (row.isLocked || row.applyLoading) {
        return
      }
      this.$set(row, 'intention', value)
      this.setActive(row)
    },
    setActive(row) {
      this.activeRowKey = row.rowKey
    },
    clearActive(row) {
      if (this.activeRowKey === row.rowKey) {
        this.activeRowKey = ''
      }
    },
    normalizePlatformCodes(platforms) {
      if (Array.isArray(platforms)) {
        return this.uniquePlatformCodes(platforms.map(item => this.getPlatformCode(item)))
      }
      if (typeof platforms === 'string') {
        return this.uniquePlatformCodes(platforms.split(/[,，、/;；]/))
      }
      if (!platforms || typeof platforms !== 'object') {
        return []
      }
      const singleCode = this.getPlatformCode(platforms)
      if (singleCode) {
        return this.uniquePlatformCodes([singleCode])
      }
      const keys = []
      const platformOrder = Array.isArray(this.infoPlatforms) && this.infoPlatforms.length
          ? this.infoPlatforms.map(item => item.value)
          : Object.keys(platforms)
      platformOrder.forEach((code) => {
        if (platforms[code] === 'Y' || platforms[code] === 1 || platforms[code] === true || platforms[code] === '1') {
          keys.push(code)
        }
      })
      return this.uniquePlatformCodes(keys)
    },
    getPlatformCode(platform) {
      if (!platform || typeof platform !== 'object') {
        return platform
      }
      return platform.platform_code || platform.platformCode || platform.code || platform.value || platform.platform_name || platform.platformName || platform.name
    },
    getPlatformLookupMap() {
      const map = new Map()
      ;(this.infoPlatforms || []).forEach((platform) => {
        const value = platform.value || platform.code || platform.name
        ;[value, platform.name, platform.display_name, platform.platform_name, platform.platform_code, platform.code].forEach((key) => {
          if (key !== undefined && key !== null && key !== '') {
            map.set(String(key).trim(), value)
            map.set(String(key).trim().toLowerCase(), value)
          }
        })
      })
      return map
    },
    normalizePlatformCodeValue(code) {
      if (code === undefined || code === null) {
        return ''
      }
      const value = String(code).trim()
      if (!value) {
        return ''
      }
      const platformMap = this.getPlatformLookupMap()
      return platformMap.get(value) || platformMap.get(value.toLowerCase()) || value
    },
    uniquePlatformCodes(codes) {
      const result = []
      const seen = new Set()
      ;(codes || []).forEach((code) => {
        if (code === undefined || code === null) {
          return
        }
        const value = this.normalizePlatformCodeValue(code)
        if (!value || seen.has(value)) {
          return
        }
        seen.add(value)
        result.push(value)
      })
      return result
    },
    getArtistKey(item, useIdFallback = true) {
      const artistId = item.artist_id || item.artistId || item.kol_id || item.kolId || item.artist?.id || (useIdFallback ? item.id : '')
      return artistId !== undefined && artistId !== null && artistId !== '' ? String(artistId) : ''
    },
    normalizeAppliedPlatformCodes(row) {
      const codes = []
      ;[
        row.selectedPlatforms,
        row.platform_code,
        row.platformCode,
        row.platform_codes,
        row.platformCodes,
        row.platforms,
        row.platform_name,
        row.platformName,
        row.platform_names,
        row.platformNames
      ].forEach((value) => {
        codes.push(...this.normalizePlatformCodes(value))
      })
      return this.uniquePlatformCodes(codes)
    },
    buildAppliedInfoMap(rows) {
      const map = new Map()
      ;(rows || []).forEach((row) => {
        const key = this.getArtistKey(row, false)
        if (!key) {
          return
        }
        const old = map.get(key) || {
          selectedPlatformCodes: [],
          appliedJournalIds: [],
          applyDetailIds: [],
          status: null,
          employ_status: null,
          confirm_status: null,
          intention: '',
          intention_note: '',
          note: ''
        }
        const appliedJournalIds = new Set((old.appliedJournalIds || []).map(Number))
        if (row.journal_id !== undefined && row.journal_id !== null && row.journal_id !== '') {
          appliedJournalIds.add(Number(row.journal_id))
        }
        map.set(key, {
          ...old,
          selectedPlatformCodes: this.uniquePlatformCodes([
            ...old.selectedPlatformCodes,
            ...this.normalizeAppliedPlatformCodes(row)
          ]),
          appliedJournalIds: [...appliedJournalIds],
          applyDetailIds: row.id !== undefined && row.id !== null ? [...old.applyDetailIds, row.id] : old.applyDetailIds,
          status: row.status || old.status,
          employ_status: (row.employ_status || 0) > (old.employ_status || 0) ? row.employ_status : old.employ_status,
          confirm_status: (row.confirm_status || 0) > (old.confirm_status || 0) ? row.confirm_status : old.confirm_status,
          intention: old.intention || row.intention || '',
          intention_note: old.intention_note || row.intention_note || '',
          note: old.note || row.note || ''
        })
      })
      return map
    },
    mergeAppliedInfo(item, appliedInfoMap) {
      const key = this.getArtistKey(item)
      const applied = key ? appliedInfoMap.get(key) : null
      if (!applied) {
        return item
      }
      return {
        ...item,
        selectedPlatforms: this.uniquePlatformCodes([
          ...this.normalizePlatformCodes(item.selectedPlatforms),
          ...applied.selectedPlatformCodes
        ]),
        appliedJournalIds: [...new Set([
          ...((item.appliedJournalIds || []).map(Number)),
          ...applied.appliedJournalIds
        ])],
        applyDetailIds: applied.applyDetailIds,
        status: item.status || applied.status || 1,
        employ_status: item.employ_status || applied.employ_status,
        confirm_status: item.confirm_status || applied.confirm_status,
        intention: applied.intention || item.intention,
        intention_note: applied.intention_note || item.intention_note || '',
        note: applied.note || item.note || ''
      }
    },
    getProjectPlatformCodes() {
      return this.uniquePlatformCodes((this.infoPlatforms || []).map(item => item.value))
    },
    computeApplyablePlatforms(item) {
      const kolSource = item.kolPlatforms && item.kolPlatforms.length ? item.kolPlatforms : item.platforms
      const kolCodes = new Set(this.normalizePlatformCodes(kolSource))
      const packageCodes = new Set(this.normalizePlatformCodes(this.packagePlatforms))
      // 可报名平台 = (红人已开通平台 K ∩ 单子要求平台 S) ∪ (单子要求平台 S ∩ 打包组合 P)
      return this.getProjectPlatformCodes().filter(code => kolCodes.has(code) || packageCodes.has(code))
    },
    normalizeIntention(item) {
      if (item.intention !== undefined && item.intention !== null && item.intention !== '') {
        return Number(item.intention)
      }
      if (Array.isArray(item.radio) && item.radio.length > 0) {
        return Number(item.radio[0])
      }
      return 2
    },
    normalizeRow(item, index) {
      const availablePlatformCodes = this.computeApplyablePlatforms(item)
      const selectedPlatformCodes = this.normalizePlatformCodes(item.selectedPlatforms)
      const remainingPlatformCodes = availablePlatformCodes.filter(code => !selectedPlatformCodes.includes(code))
      const hasApplied = selectedPlatformCodes.length > 0 || Boolean(item.status) || item.confirm_status === 2 || item.employ_status === 2
      return {
        ...item,
        rowKey: item.id !== undefined && item.id !== null ? String(item.id) : `row-${index}`,
        intention: this.normalizeIntention(item),
        checkList: [],
        appliedJournalIds: Array.isArray(item.appliedJournalIds) ? item.appliedJournalIds : [],
        availablePlatformCodes,
        selectedPlatformCodes,
        remainingPlatformCodes,
        note: item.note || '',
        intention_note: item.intention_note || '',
        isApplied: hasApplied,
        isLocked: false,
        sourceIndex: index,
        applyLoading: false
      }
    },
    getRowSortWeight(row) {
      const canContinue = Array.isArray(row.remainingPlatformCodes) && row.remainingPlatformCodes.length > 0
      if (row.isApplied) {
        // 已报名：可继续报名靠前，无可报名平台锁定靠后
        return canContinue ? 1 : 2
      }
      // 未报名：可报名靠前，无可报名平台靠后
      return canContinue ? 0 : 3
    },
    buildGroupList(list) {
      const groupMap = new Map()
      list.forEach((item, index) => {
        const row = this.normalizeRow(item, index)
        const groupId = row.group_id !== undefined && row.group_id !== null && row.group_id !== ''
            ? String(row.group_id)
            : `group-${row.group_name || 'default'}`
        const groupKey = `${groupId}-${row.group_name || '未分组'}`
        if (!groupMap.has(groupKey)) {
          groupMap.set(groupKey, {
            rowKey: groupKey,
            group_id: groupId,
            group_name: row.group_name || '未分组',
            children: []
          })
        }
        const children = groupMap.get(groupKey).children
        children.push(row)
        // 未报名可报排前，继续报名/已报名居中，无可报名平台排后；同状态保持接口返回顺序
        children.sort((a, b) => this.getRowSortWeight(a) - this.getRowSortWeight(b) || a.sourceIndex - b.sourceIndex)
      })

      return Array.from(groupMap.values()).map((group) => {
        const total = group.children.length
        const appliedCount = group.children.filter(item => item.isApplied).length
        return {
          ...group,
          total,
          appliedCount,
          progress: total > 0 ? Math.round((appliedCount / total) * 100) : 0
        }
      })
    },
    getPlatformOptions(row) {
      const codes = row.availablePlatformCodes || []
      if (!codes.length) {
        return []
      }
      const platformMap = new Map((this.infoPlatforms || []).map(item => [item.value, item]))
      const options = []
      codes.forEach((code) => {
        const platform = platformMap.get(code) || {value: code, name: code}
        // 平台下的账号（journal，即红人在该平台的账号）——同一平台可能有多账号，每个账号一个可勾选 chip
        const journals = (row.journals || []).filter(val => String(val.code) === String(platform.value))
        journals.forEach((journal) => {
          const key = `J${journal.id}`
          options.push({
            artist_id: row.id,
            key,
            value: key,
            platform_code: platform.value,
            platform_name: platform.name,
            name: platform.name,
            color: this.getPlatformThemeColor(platform),
            journal,
            applied: this.isPlatformAccountApplied(row, platform.value, journal),
            selected: this.isPlatformAccountSelected(row, platform.value, journal)
          })
        })
      })
      return options
    },
    isPlatformAccountSelected(row, platformCode, journal) {
      if (!Array.isArray(row.checkList)) {
        return false
      }
      return row.checkList.some(tok => tok && Number(tok.journal_id) === Number(journal && journal.id))
    },
    isPlatformAccountApplied(row, platformCode, journal) {
      // 账号级：我的报名明细中已含该账号(journal)
      if (journal && journal.id != null && (row.appliedJournalIds || []).map(Number).includes(Number(journal.id))) {
        return true
      }
      // 兼容：无账号(历史)的平台级已报名，整个平台视为已报
      if (!journal && (row.selectedPlatformCodes || []).includes(platformCode)) {
        return true
      }
      return false
    },
    togglePlatform(row, option) {
      if (row.isLocked || option.applied) {
        return
      }
      const journal = option.journal
      const journalId = journal ? Number(journal.id) : null
      const tokens = Array.isArray(row.checkList) ? [...row.checkList] : []
      const idx = tokens.findIndex(tok => tok && journalId !== null && Number(tok.journal_id) === journalId)
      if (idx > -1) {
        tokens.splice(idx, 1)
      } else {
        tokens.push({
          platform_code: option.platform_code,
          platform_name: option.platform_name,
          journal_id: journalId,
          account_id: journal ? journal.account_id : null
        })
      }
      this.$set(row, 'checkList', tokens)
      this.setActive(row)
    },
    getPlatformThemeColor(platform) {
      const color = platform.color || platform.color_val || platform.color_value || platform.theme_color
      if (color) {
        return color
      }
      const platformKey = String(platform.value || platform.name || '').toLowerCase()
      const colorMap = {
        douyin: '#111827',
        tiktok: '#111827',
        xiaohongshu: '#ff2442',
        xhs: '#ff2442',
        redbook: '#ff2442',
        kuaishou: '#ff6a00',
        ks: '#ff6a00',
        weibo: '#ff8200',
        bilibili: '#00aeec',
        bilili: '#00aeec',
        b站: '#00aeec',
        shipinhao: '#07c160',
        wx_video: '#07c160',
        package: '#6b5cff',
        抖音: '#111827',
        小红书: '#ff2442',
        快手: '#ff6a00',
        微博: '#ff8200',
        视频号: '#07c160'
      }
      return colorMap[platformKey] || '#5b5ff5'
    },
    getPlatformStyle(platform) {
      const bgColor = this.hexToRgba(platform.color, 0.1)
      const borderColor = this.hexToRgba(platform.color, 0.3)
      const shadowColor = this.hexToRgba(platform.color, 0.25)
      return {
        '--platform-color': platform.color,
        '--platform-bg': bgColor,
        '--platform-border': borderColor,
        '--platform-shadow': shadowColor
      }
    },
    hexToRgba(color, opacity) {
      if (!/^#[0-9a-f]{6}$/i.test(color)) {
        return color
      }
      const r = parseInt(color.slice(1, 3), 16)
      const g = parseInt(color.slice(3, 5), 16)
      const b = parseInt(color.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${opacity})`
    },
    canApply(row) {
      if (row.isLocked || row.applyLoading) {
        return false
      }
      return row.checkList && row.checkList.length > 0 && row.intention !== undefined && row.intention !== null && row.intention !== ''
    },
    getActionText(row) {
      if (row.isLocked) {
        return row.isApplied ? '已报' : '报名'
      }
      return row.isApplied ? '继续报名' : '报名'
    },
    // 状态体系与已报名列表(enrolledTable)保持一致：已合作 > 已初选 > 已报名，未报名显示待报
    getStatusClass(item) {
      if (!item.isApplied) {
        return 'is-pending'
      }
      if (item.confirm_status === 2) {
        return 'is-applied'
      }
      if (item.employ_status === 2) {
        return 'is-pending'
      }
      return 'is-default'
    },
    getStatusText(item) {
      if (!item.isApplied) {
        return '待报'
      }
      if (item.confirm_status === 2) {
        return '已合作'
      }
      if (item.employ_status === 2) {
        return '已初选'
      }
      return '已报名'
    },
    async handleApply(row) {
      if (!this.canApply(row)) {
        this.$message.warning('请先确认合作意向和报名平台')
        return
      }
      this.setActive(row)
      const platformMap = new Map((this.infoPlatforms || []).map(item => [item.value, item.name]))
      const platforms = (row.checkList || []).map((tok) => {
        return {
          platform_code: tok.platform_code,
          platform_name: tok.platform_name || platformMap.get(tok.platform_code) || tok.platform_code,
          journal_id: tok.journal_id
        }
      })
      this.$confirm(`确认给【${row.nickname || '该红人'}】报名?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$set(row, 'applyLoading', true)
        try {
          // const preMap = await this.fetchPreList([row])
          const payload = {
            kols: [
              {
                artist_id: row.id,
                intention: Number(row.intention),
                platforms,
                is_assign: row.is_assign ? 1 : 2,
                nickname: row.nickname,
                intention_note: row.intention_note || '',
                note: row.note || '',
                // plc_item_ids: this.extractPlcItemIds(preMap[row.id])
              }
            ],
            project_id: this.projectId
          }
          const id = await this.$api.InquiryEnroll(payload)
          if (id) {
            this.$notify.success('报名成功')
            this.rememberApplyGroup(row)
            await this.getInfo()
            this.$emit('refresh')
          } else {
            this.$message.error('报名失败')
          }
        } catch (error) {
          this.$message.error('报名失败')
        } finally {
          this.$set(row, 'applyLoading', false)
          this.clearActive(row)
        }
      }).catch(() => {
        this.clearActive(row)
        this.$notify.info('已取消')
      })
    },
    async handleBatchApply() {
      const rows = this.batchRows
      if (rows.length < 2) {
        this.$message.warning('请至少勾选 2 位红人的报名平台')
        return
      }
      const platformMap = new Map((this.infoPlatforms || []).map(item => [item.value, item.name]))
      const platformObjMap = new Map((this.infoPlatforms || []).map(item => [item.value, item]))

      // 清单式确认：每位红人一张卡片，带头像与平台彩色标签，列明报名平台/档期/备注
      const listHtml = rows.map((item) => {
        const nickname = item.nickname || '该红人'
        const platformChips = (item.checkList || []).map((tok) => {
          const pc = tok.platform_code
          const platform = platformObjMap.get(pc) || {value: pc, name: tok.platform_name || platformMap.get(pc) || pc}
          const color = this.getPlatformThemeColor(platform)
          const bg = this.hexToRgba(color, 0.12)
          const border = this.hexToRgba(color, 0.35)
          const label = tok.account_id ? `${this.escapeHtml(platform.name || pc)} (${this.escapeHtml(tok.account_id)})` : this.escapeHtml(platform.name || pc)
          return `<span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:12px;font-weight:500;color:${color};background:${bg};border:1px solid ${border};margin-right:6px">${label}</span>`
        }).join('')
        const schedule = (item.intention_note || '').trim()
        const note = (item.note || '').trim()
        const assignTag = item.is_assign === 1 ? '<span style="color:#ff3176;font-size:12px;font-weight:600;background:rgba(255,49,118,0.1);padding:1px 6px;border-radius:4px;margin-left:4px">定向</span>' : ''
        return `<div style="border:1px solid #ebeef5;border-radius:10px;padding:12px 14px;margin-bottom:12px;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.04)">
  <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">
    <span style="width:28px;height:28px;border-radius:50%;background:${this.getAvatarColor(nickname)};color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:12px;flex:0 0 auto">${this.getAvatarText(nickname)}</span>
    <span style="font-size:15px;font-weight:600;color:#303133">${this.escapeHtml(nickname)}</span>
    ${assignTag}
  </div>
  <div style="margin-bottom:6px">
    <span style="color:#909399;font-size:13px;margin-right:6px">报名平台</span>
    ${platformChips}
  </div>
  <div style="display:flex;flex-wrap:wrap;gap:6px 16px;font-size:13px;color:#606266">
    <span><b style="color:#909399;font-weight:400">档期</b> ${schedule ? this.escapeHtml(schedule) : '<span style="color:#c0c4cc">无</span>'}</span>
    <span><b style="color:#909399;font-weight:400">备注</b> ${note ? this.escapeHtml(note) : '<span style="color:#c0c4cc">无</span>'}</span>
  </div>
</div>`
      }).join('')
      const message = `<div style="text-align:left;max-height:440px;overflow:auto;padding:2px">
  <div style="margin-bottom:12px;padding-bottom:10px;border-bottom:1px dashed #ebeef5;color:#303133;font-size:15px;font-weight:600">确认给以下 ${rows.length} 位红人批量报名？</div>
  ${listHtml}
</div>`

      this.$confirm(message, '批量报名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        this.batchLoading = true
        try {

          // const preMap = await this.fetchPreList(rows)
          const payload = {
            kols: rows.map((item) => {
              return {
                artist_id: item.id,
                intention: Number(item.intention),
                platforms: (item.checkList || []).map(tok => {
                  return {
                    platform_code: tok.platform_code,
                    platform_name: tok.platform_name || platformMap.get(tok.platform_code) || tok.platform_code,
                    journal_id: tok.journal_id
                  }
                }),
                is_assign: item.is_assign ? 1 : 2,
                nickname: item.nickname,
                intention_note: item.intention_note || '',
                note: item.note || '',
                // plc_item_ids: this.extractPlcItemIds(preMap[item.id])
              }
            }),
            project_id: this.projectId
          }
          const id = await this.$api.InquiryEnroll(payload)
          if (id) {
            this.$notify.success('批量报名成功')
            await this.getInfo()
            this.$emit('refresh')
          } else {
            this.$message.error('批量报名失败')
          }
        } catch (error) {
          this.$message.error('批量报名失败')
        } finally {
          this.batchLoading = false
        }
      }).catch(() => {
        this.$notify.info('已取消')
      })
    },
    // 提交前预取：与 applyDrawer 确认报名同款，用于提取 plc_item_ids（刊例报价 item id）
    // async fetchPreList(rows) {
    //   const checkData = rows.map((item) => ({
    //     id: item.id,
    //     intention: Number(item.intention),
    //     platform_code:item.platform_code,
    //     journal_id:item.journal_id,
    //     platforms: [...new Set((item.checkList || []).map(tok => tok && tok.platform_code).filter(Boolean))],
    //     nickname: item.nickname,
    //     is_assign: item.is_assign,
    //     intention_note: item.intention_note || '',
    //     note: item.note || ''
    //   }))
    //   console.log(checkData)
    //   const coopId = this.infoStatus && this.infoStatus.coop_id
    //   const isQa = Number(coopId) === 11052 || !coopId
    //   const data = isQa ? {kols: checkData, is_qa: 'Y'} : {kols: checkData}
    //   const list = await this.$api.preDataInquiryApply(data)
    //   return Object.fromEntries((list || []).map(i => [i.artist_id, i]))
    // },
    // 从预取数据的 list 中提取刊例报价 item id 数组
    extractPlcItemIds(pre) {
      if (!pre || !pre.list) {
        return []
      }
      return Object.values(pre.list).flatMap(listItem => (listItem.plc_items ? listItem.plc_items.map(j => j.id) : []))
    },
    getAvatarText(name) {
      const text = String(name || '').replace(/\s+/g, '').trim()
      if (!text) {
        return '-'
      }
      return text.slice(0, 2)
    },
    escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, (char) => {
        const map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }
        return map[char]
      })
    },
    getAvatarColor(name) {
      const text = String(name || '')
      let hash = 0
      for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i)
        hash |= 0
      }
      const hue = Math.abs(hash) % 220
      return `hsl(${hue}, 82%, 62%)`
    },
    async getInfo(projectId) {
      this.loading = true
      try {
        this.projectId = projectId|| this.$route.params.id
        const [data, appliedData] = await Promise.all([
          this.$api.InquiryKolList({project_id: this.projectId}),
          this.$api.applyList({
            project_id: this.projectId,
            status: this.infoStatus.status
          }).catch(() => ({details_all_about_me: []}))
        ])
        const list = Array.isArray(data) ? data : []
        const appliedInfoMap = this.buildAppliedInfoMap(appliedData.details_all_about_me || [])
        this.groupList = this.buildGroupList(list.map(item => this.mergeAppliedInfo(item, appliedInfoMap)))
        const lastGroup = this.readLastApplyGroup()
        if (lastGroup && this.groupList.some(g => g.rowKey === lastGroup)) {
          this.expandRowKeys = [lastGroup]
        } else {
          this.expandRowKeys = this.groupList.length > 0 ? [this.groupList[0].rowKey] : []
        }
        console.log(this.groupList)
      } catch (error) {
        this.groupList = []
        this.expandRowKeys = []
        this.$message.error('加载报名列表失败')
      } finally {
        this.loading = false
      }
    },
    rememberApplyGroup(row) {
      const groupId = row.group_id !== undefined && row.group_id !== null && row.group_id !== ''
          ? String(row.group_id)
          : `group-${row.group_name || 'default'}`
      const groupKey = `${groupId}-${row.group_name || '未分组'}`
      try {
        window.localStorage.setItem(`inquiry_last_apply_group_${this.projectId}`, groupKey)
      } catch (e) {
        // 存储失败忽略，不影响报名流程
      }
    },
    readLastApplyGroup() {
      try {
        return window.localStorage.getItem(`inquiry_last_apply_group_${this.projectId}`) || ''
      } catch (e) {
        return ''
      }
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="scss" scoped>
.apply-list-wrap {
  --inquiry-accent: #5b6cff;
  --inquiry-accent-soft: rgba(91, 108, 255, 0.10);
  --inquiry-accent-strong: rgba(91, 108, 255, 0.20);
  padding: 16px 18px 18px;
  border-radius: 8px;
  /* 表格最小宽度兜底：屏幕缩到 min-width 以下时横向滚动，不再堆叠换行 */
  overflow-x: auto;
  min-height: 400px;
}

.batch-apply-float {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 22px;
  border-radius: 24px;
  background: linear-gradient(135deg, #ff5f8f, #ff3176);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(255, 49, 118, 0.35);
  cursor: pointer;
  user-select: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.batch-apply-float:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(255, 49, 118, 0.45);
}

.batch-apply-float:active {
  transform: translateY(0);
}

.apply-group-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.apply-group {
  width: 100%;
}

.group-card {
  min-height: 58px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.group-card.open {
  background: #f5f7ff;
}

.group-card:hover {
  background: #f5f7ff;
}

.group-card-left,
.group-card-right,
.group-title-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
}

.group-card-right {
  gap: 14px;
  flex: 0 0 auto;
}

.group-dot {
  width: 9px;
  height: 9px;
  margin-right: 13px;
  border-radius: 50%;
  background: var(--inquiry-accent);
  box-shadow: 0 0 0 4px var(--inquiry-accent-soft);
  flex: 0 0 auto;
}

.group-name {
  max-width: 360px;
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group-total {
  height: 24px;
  margin-left: 14px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  background: #edf0f7;
  color: #536174;
  font-size: 12px;
  line-height: 24px;
  flex: 0 0 auto;
}

.group-progress {
  width: 88px;
}

.group-ratio {
  min-width: 42px;
  color: #66809f;
  font-size: 12px;
  text-align: right;
}

.group-arrow {
  color: #8d9aaf;
  font-size: 16px;
  transition: transform 0.2s ease;
}

.group-arrow.open {
  transform: rotate(90deg);
}

.detail-wrap {
  padding: 6px 0 0;
}

.detail-head,
.kol-row {
  display: grid;
  grid-template-columns: minmax(100px, 0.95fr) minmax(72px, 0.75fr) minmax(90px, 0.92fr) minmax(132px, 1.12fr) minmax(96px, 0.96fr) 84px 84px;
  /* 正常宽度按 fr 弹性撑满不压缩；仅当可用宽度不足 1000px 时固定 1000px 横向滚动，保持列宽不变 */
  min-width: 1000px;
  column-gap: 12px;
  align-items: center;
}

.detail-head {
  min-height: 38px;
  padding: 0 18px;
  color: #8793a8;
  font-size: 12px;
}

.kol-row {
  position: relative;
  overflow: hidden;
  min-height: 58px;
  margin-bottom: 10px;
  padding: 10px 14px;
  border: 1px solid #e6ebf3;
  border-left: 4px solid transparent;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(16, 24, 40, 0.05);
}

.kol-row.row-disabled {
  cursor: not-allowed;
}

.kol-row.row-active {
  border-color: #d9e0ff;
  border-left-color: var(--inquiry-accent);
  background: #f7f9ff;
  box-shadow: 0 1px 8px var(--inquiry-accent-strong);
}

.kol-row > * {
  position: relative;
  z-index: 1;
}

.row-watermark {
  position: absolute;
  inset: 0 12px;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 18px;
  padding: 0 8px;
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  overflow: hidden;
}

.row-watermark span {
  flex: 0 0 auto;
  color: #eef1ff;
  font-size: 23px;
  font-weight: 900;
  letter-spacing: 6px;
  line-height: 1;
  transform: rotate(-10deg);
}

.kol-row:last-child {
  margin-bottom: 0;
}

.kol-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.kol-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  overflow: hidden;
}

.kol-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.kol-info,
.schedule-cell,
.note-cell,
.platform-group {
  min-width: 0;
}

.kol-name {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.kol-name-text {
  color: #0f172a;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kol-sub {
  margin-top: 2px;
  color: #8a96ab;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-tag {
  height: 20px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 500;
  flex: 0 0 auto;
}

.intention-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.platform-group-inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.intention-switch {
  display: inline-flex;
  width: 70%;
  height: 28px;
  padding: 2px;
  border-radius: 7px;
  background: #eef1f6;
}

.switch-seg {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-size: 12px;
  line-height: 1;
  color: #7a8396;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.switch-seg.active {
  background: #fff;
  color: var(--inquiry-accent);
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}

.intention-note-input {
  width: 100%;
}

.schedule-cell {
  display: flex;
  align-items: center;
}

::v-deep .intention-note-input .el-input__inner {
  height: 28px;
  border-color: transparent;
  border-radius: 6px;
  background: #eef2f8;
  color: #334155;
}

::v-deep .intention-note-input .el-input__inner:focus {
  border-color: var(--inquiry-accent);
  background: #fff;
}

.status-pill {
  height: 24px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.status-pill .status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: 0 0 auto;
}

/* 待报：暖色调，参照参考图 */
.status-pill.is-pending {
  border: 1px solid #f0d9a6;
  background: #fdf6e3;
  color: #a16207;
}

.status-pill.is-pending .status-dot {
  background: #d97706;
}

/* 已报：成功绿对称 */
.status-pill.is-applied {
  border: 1px solid #b7e3c4;
  background: #effaf3;
  color: #1e7a46;
}

.status-pill.is-applied .status-dot {
  background: #22a55c;
}

/* 已报名：浅绿色（与已合作绿色保持可辨差异） */
.status-pill.is-default {
  border: 1px solid #c3e6d3;
  background: #e6f7ee;
  color: #1e7a46;
}

.status-pill.is-default .status-dot {
  background: #2f9e62;
}

.platform-chip {
  height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #e3e8f2;
  border-radius: 10px;
  background: #fff;
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.platform-chip:not(.applied):not(.selected):hover {
  transform: translateY(-1px);
  border-color: #d2d8e4;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.platform-chip.applied,
.platform-chip.selected {
  border-color: #b6e6c0;
  background: #eefaf1;
  color: #1f7a46;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(73, 181, 100, 0.12);
}

.platform-chip.selected:hover {
  border-color: #9ed7aa;
}

.platform-chip.disabled {
  cursor: not-allowed;
}

.platform-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
  position: relative;
}

.platform-check {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ff4f8b;
  color: #fff;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.note-input {
  width: 100%;
}

::v-deep .note-input .el-input__inner {
  height: 30px;
  border-color: transparent;
  border-radius: 6px;
  background: #eef2f8;
  color: #334155;
}

::v-deep .note-input .el-input__inner:focus {
  border-color: var(--inquiry-accent);
  background: #fff;
}

.status-cell,
.action-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .action-cell .el-button--mini {
  min-width: 70px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: var(--inquiry-accent);
  box-shadow: 0 6px 14px rgba(91, 108, 255, 0.24);
}

::v-deep .action-cell .el-button--mini.is-disabled,
::v-deep .action-cell .el-button--mini.is-disabled:hover {
  border-color: #cdd5e4;
  background: #cdd5e4;
  box-shadow: none;
}

.muted {
  color: #a0a8b8;
  font-size: 13px;
}

.empty-text {
  padding: 28px 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
  min-height: 200px;
}
</style>
